export const CsvDelimiter = {
    COMMA: 'comma',
    SEMICOLON: 'semicolon',
};
